<template>
  <div class="site-footer-copyright">
    © {{ new Date().getFullYear() }}
    {{ __("All rights reserved", "egalite") }}
  </div>
</template>
